export const REGEX_PATTERNS = {
    ID: /^\d{9}$/,
    EMAIL: /^\s*([\w!#$%&'*+-/=?^`{|}~]+\.)*[\w!#$%&'*+-/=?^`{|}~]+@((((([a-zA-Z0-9]{1}[a-zA-Z0-9-]{0,62}[a-zA-Z0-9]{1})|[a-zA-Z])\.)+[a-zA-Z]{2,6})|(\d{1,3}\.){3}\d{1,3}(:\d{1,5})?)\s*$/,
    CELL: /^\s*(?:(0(?:50|51|52|53|54|55|57|58|72|73|74|76|77|78)[-]?[0-9]{7}))\s*$/,
    PHONE: /^\s*(?:(0(?:2|3|4|8|9|7|50|51|52|53|54|55|56|57|58|59|72|73|74|76|77|78)[-]?[0-9]{7}))\s*$/,
    FIRST_NAME: /^\s*[\u0590-\u05FFa-zA-Z'"-]{2,}(?:[\s'-][\u0590-\u05FFa-zA-Z'"-]+)*\s*$/,
    LAST_NAME: /^\s*[\u0590-\u05FFa-zA-Z'"-]{2,}(?:[\s'-][\u0590-\u05FFa-zA-Z'"-]+)*\s*$/,
    FULL_NAME: /^[\u0590-\u05FFa-zA-Z'"-]{2,}(?:[\s'-][\u0590-\u05FFa-zA-Z'"-]+)*\s+[\u0590-\u05FFa-zA-Z'"-]{2,}(?:[\s'-][\u0590-\u05FFa-zA-Z'"-]+)*$/,
    NAME: /^([\u0590-\u05FFa-zA-Z]{2,})+\s([\u0590-\u05FFa-zA-Z]{2,})+$|^([\u0590-\u05FFa-zA-Z]{2,})+$/,
    URL: /^(https?:\/\/)?(www\.)?([a-zA-Z0-9@:%._\+~#?&//=]+\.){1,}[a-z]{2,6}\b([-a-zA-Z0-9@:%._\+~#?&//=]*)+$/
};

export const VALIDATION_MESSAGES = {
    NOT_EMPTY: 'שדה חובה',
    REQUIRED: 'שדה חובה',
    SECTOR: 'יש להשלים תחום עיסוק',
    ONLY_NUMBERS: 'יש להזין רק מספרים',
    EMAIL: 'כתובת דוא"ל שגויה',
    CELL: 'מספר סלולרי שגוי',
    PHONE: 'מספר טלפון שגוי',
    ID: 'תעודת זהות לא תקינה',
    FULL_NAME: 'שם מלא לא תקין',
    FIRST_NAME: 'שם פרטי לא תקין',
    LAST_NAME: 'שם משפחה לא תקין',
    LAST_DIGITS: 'אנא הזינו 4 ספרות אחרונות בכרטיס האשראי',
    CHECKED_CHECKBOX: 'יש לאשר את האמור',
    URL: 'כתובת אתר העסק לא תקינה',
    AGE_RESTRICTION: 'השימוש בשירות מגיל 14 ומעלה בלבד',
    SHOULD_ADD_EMAIL_IF_NOT_EXISTS: 'אימייל לא קיים במערכת יש לעדכן באיזור האישי'
};

export const is_valid_israeli_id_number = id => {
    const normalizedId = String(id).trim();

    const isValidFormat = /^[0-9]*$/.test(normalizedId) && normalizedId.length >= 5;

    if (!isValidFormat) {
        return false;
    }

    const normalizedIdWithLeadingZeros = ("00000000" + normalizedId).slice(-9);

    return Array.from(normalizedIdWithLeadingZeros, Number).reduce((counter, digit, i) => {
        const step = digit * ((i % 2) + 1);
        return counter + (step > 9 ? step - 9 : step);
    }) % 10 === 0;
};

export default function Validate(value, rules) {
    const Validations = {
        not_empty: {
            valid: val => val !== '',
            msg: VALIDATION_MESSAGES.NOT_EMPTY,
        },
        should_add_email_if_not_exists: {
            valid: val => val !== '',
            msg: VALIDATION_MESSAGES.SHOULD_ADD_EMAIL_IF_NOT_EXISTS,
        },
        sector: {
            valid: val => val !== '',
            msg: VALIDATION_MESSAGES.SECTOR,
        },
        only_numbers: {
            valid: val => /^\d+$/.test(val),
            msg: VALIDATION_MESSAGES.ONLY_NUMBERS,
        },
        email: {
            valid: val => REGEX_PATTERNS.EMAIL.test(val),
            msg: VALIDATION_MESSAGES.EMAIL,
        },
        should_add_email_if_not_exists: {
            valid: val => val === '' || REGEX_PATTERNS.EMAIL.test(val),
            msg: VALIDATION_MESSAGES.EMAIL,
        },
        cell: {
            valid: val => REGEX_PATTERNS.CELL.test(val),
            msg: VALIDATION_MESSAGES.CELL,
        },
        cell_optional: {
            valid: val => val === '' || REGEX_PATTERNS.CELL.test(val),
            msg: VALIDATION_MESSAGES.CELL,
        },
        phone: {
            valid: val => REGEX_PATTERNS.PHONE.test(val),
            msg: VALIDATION_MESSAGES.PHONE,
        },
        id: {
            valid: val => is_valid_israeli_id_number(val),
            msg: VALIDATION_MESSAGES.ID,
        },
        user_id: {
            valid: val => is_valid_israeli_id_number(val),
            msg: VALIDATION_MESSAGES.ID,
        },
        personal_id: {
            valid: val => is_valid_israeli_id_number(val),
            msg: VALIDATION_MESSAGES.ID,
        },
        full_name: {
            valid: val => REGEX_PATTERNS.FULL_NAME.test(val) && !/--/.test(val),
            msg: VALIDATION_MESSAGES.FULL_NAME,
        },
        first_name: {
            valid: val => REGEX_PATTERNS.FIRST_NAME.test(val),
            msg: VALIDATION_MESSAGES.FIRST_NAME,
        },
        last_name: {
            valid: val => REGEX_PATTERNS.LAST_NAME.test(val),
            msg: VALIDATION_MESSAGES.LAST_NAME,
        },
        last_digits:{
            valid: val => /^[0-9]*$/.test(val) && val.length === 4,
            msg: VALIDATION_MESSAGES.LAST_DIGITS,
        },
        checked_checkbox: {
            valid: val => Boolean(val),
            msg: VALIDATION_MESSAGES.CHECKED_CHECKBOX,
        },
        url: {
            valid: val => REGEX_PATTERNS.URL.test(val),
            msg: VALIDATION_MESSAGES.URL
        }
    };

    let valid = true;
    let msg   = '';

    const formatValue = (value) => {
        if (typeof value === 'string') {
            value = value.trim();
        }

        return value;
    }

    rules.forEach((rule) => {
        if(!Validations[rule].valid(
            formatValue(value)
        )) {
            valid = false;
            msg = Validations[rule].msg;
        }
    });

    return {valid:valid,msg:msg};
}
